import { ASSETS_BASE_URL } from 'app/utils/urls'

export const iframeStyles = `
@font-face {
  font-family: "IranSans";
  src: url(${ASSETS_BASE_URL}/webappAssets/fonts/IRANSansXFaNum-RegularD4.woff) format("woff");
  font-weight: 300;
}
@font-face {
  font-family: "IranSans_medium";
  src: url(${ASSETS_BASE_URL}/webappAssets/fonts/IRANSansXFaNum-MediumD4.woff) format("woff");
  font-weight: 400;
}
@font-face {
  font-family: "IranSans_bold";
  src: url(${ASSETS_BASE_URL}/webappAssets/fonts/IRANSansXFaNum-BoldD4.woff) format("woff");
  font-weight: bold;
}

html{
  margin: 0;
  padding: 0;
  overflow: hidden;
}

html * {
  box-sizing: border-box;
  margin-block-start: 0;
  margin-block-end: 0;
  unicode-bidi: plaintext;
}

body {
  margin: 0;
  height : 100%;
  font-family : 'IranSans';
  font-size: 12px;
  line-height: 18px;
  word-break: initial;
  color: rgba(0, 0, 0, 0.8);
}

img {
  cursor : unset !important;
}

@media only screen and (max-device-width: 667px) {
  body {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/* Target the WebKit-based browsers */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 200px;
}

::-webkit-scrollbar-thumb {
  background-color: #f1f1f1;
  border: 3px solid transparent;
  border-width: 3px;
  border-radius: 9px;
  background-clip: content-box;
}

/* Target Mozilla Firefox */
::-moz-scrollbar {
  width: 10px;
}

/* Target Internet Explorer and older versions of Microsoft Edge */
::-ms-scrollbar {
  width: 10px;
}
`
